"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalBookingAgent = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var ExternalBookingAgent;
(function (ExternalBookingAgent) {
    ExternalBookingAgent.Schema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        role: centralized_zod_1.z.literal("external-booking-agent"),
        firstName: centralized_zod_1.z.string(),
        lastName: centralized_zod_1.z.string(),
    });
})(ExternalBookingAgent || (ExternalBookingAgent = {}));
exports.ExternalBookingAgent = ExternalBookingAgent;
